/**
 * Map venue dashboard paths onto Growth Engine feature_opened.
 * Dedicated screens only — shared pages (shopping lists / orders) must not
 * invent a featureId. Card clicks stay recommendation_clicked; this event is
 * “they reached the screen,” including nav looky-loos with no card.
 */

import { normalizeGrowthEnginePath } from './growthEngineNudgeRefresh'

export const GROWTH_ENGINE_FEATURE_OPENED_EVENT = 'feature_opened'

/** How the client recorded this open. Screen mount is independent of a card. */
export const GROWTH_ENGINE_FEATURE_OPENED_SOURCE = 'screen_mount'

/**
 * @param {string|null|undefined} pathname
 * @returns {{ featureId: string, surface: string }|null}
 */
export function resolveFeatureOpenedFromPath(pathname) {
  const parts = normalizeGrowthEnginePath(pathname).split('/').filter(Boolean)
  if (parts[0] !== 'v' || parts.length < 3) return null

  const rest = parts.slice(2)

  if (rest[0] === 'menu-builder') {
    return { featureId: 'recipes', surface: 'menu_builder' }
  }
  if (rest[0] === 'stockTakes') {
    return { featureId: 'stock_takes', surface: 'stock_takes' }
  }
  if (rest[0] === 'suppliers') {
    return { featureId: 'suppliers', surface: 'suppliers' }
  }
  if (rest[0] === 'purchasing' && rest[1] === 'invoices') {
    return { featureId: 'invoice_uploads', surface: 'invoices' }
  }
  if (rest[0] === 'purchasing' && rest[1] === 'receipting') {
    return { featureId: 'goods_receipting', surface: 'receipting' }
  }
  if (rest[0] === 'receipting') {
    return { featureId: 'goods_receipting', surface: 'receipting' }
  }
  return null
}

const openedThisVisit = new Set()

const visitKey = (venueId, featureId) => `${venueId}:${featureId}`

/** @returns {boolean} true if this is a new visit and should be posted */
export function beginFeatureOpenedVisit(venueId, featureId) {
  if (!venueId || !featureId) return false
  const key = visitKey(venueId, featureId)
  if (openedThisVisit.has(key)) return false
  openedThisVisit.add(key)
  return true
}

export function endFeatureOpenedVisit(venueId, featureId) {
  if (!venueId || !featureId) return
  openedThisVisit.delete(visitKey(venueId, featureId))
}

export function __resetGrowthEngineFeatureOpenedVisitsForTests() {
  openedThisVisit.clear()
}
